import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type Note } from '../reusable/Notes'

type GetNotesQueryArgs = {
  memberId?: string
  employerId?: string
  subjectType?: string
  subjectId?: string
}

type GetNotesParams = {
  displayExistingNotes?: boolean
} & GetNotesQueryArgs

export function getNotesQueryKey ({ memberId, employerId, subjectType, subjectId }: GetNotesQueryArgs) {
  return ['brokers', 'notes', memberId || employerId || `${subjectType}-${subjectId}`]
}

export function useGetNotes ({ memberId, displayExistingNotes, employerId, subjectType, subjectId }: GetNotesParams) {
  return useQuery<Note[], GrapeAPIErrorType>({
    queryKey: getNotesQueryKey({ memberId, employerId, subjectType, subjectId }),
    queryFn: async () => {
      const queryParams: Record<string, any> = {
        ...(memberId ? { member_id: memberId } : {}),
        ...(employerId ? { employer_id: employerId } : {}),
        ...(subjectType ? { subject_type: subjectType } : {}),
        ...(subjectId ? { subject_id: subjectId } : {}),
      }
      const queryString = new URLSearchParams(queryParams).toString()

      const response = await fetchWithHeaders(`/api/web/brokers/notes?${queryString}`)
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message ?? 'Failed to fetch broker notes',
          errors: errorJson.errors,
        })
      }
      const { data } = await response.json()
      return data
    },
    retry: false,
    enabled: displayExistingNotes,
  })
}
